import React from 'react'

export default function Footer() {
  return (
    <footer className="footer text-center">
      carbon12.co © 2023 All rights reserved
    </footer>
  )
}
